import React, { useMemo } from 'react';
import './index.less';
import SkuDataFunnel from '../sku-datafunnel';
import IconTip from '@/components/icon-tip';
import { formatPrice } from '@/common/utils';
//左侧柱图配置
const lightColor = [
  'l (180)  0:rgba(233, 239, 255, 0) 1:rgba(233, 239, 255, 1)',
  'l (180)  0:rgba(255, 255, 255, 0) 1:rgba(217, 239, 255, 1)',
  'l (180)  0:rgba(225, 251, 238, 0) 1:rgba(222, 249, 235, 1)',
];
//漏斗图配置
const darkColor = ['#568CFF', '#5CBBFF', '#3BD186'];

const SkuEffect = (props) => {
  const res = useMemo(() => getData(props.data), [props.data]);
  const funnel = useMemo(() => {
    return <SkuDataFunnel {...res} isSku={true} />;
  }, [res]);
  return (
    <div>
      <div className="sku-effect-title">
        SKU转化效果
        <IconTip
          title={
            <ul style={{ paddingLeft: 20, paddingTop: 10, paddingRight: 6 }}>
              <li>曝光sku数：活动会场中有曝光UV的sku数量按天去重，多天则累加</li>
              <li>点击sku数：通过活动会场有点击的sku数量按天去重，多天则累加</li>
              <li>
                直接引导成交sku数：活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，成交的sku数为直接引导成交sku数
              </li>
            </ul>
          }
          type="question"
          size="small"
        />
      </div>
      {funnel}
    </div>
  );

  function getData(datasource) {
    const rawData = {
      // putonSku: {
      //   id: 'putonSku',
      //   name: '上场SKU数',
      //   desc: '上场',
      //   value: datasource.putonSkuNums,
      //   labelContent: `${'SKU曝光率'}${'\n'}${datasource.expoSkuRate ? datasource.expoSkuRate : '-'}`,
      //   textColor: '#79A1FF', 3BD186
      // },
      expoSku: {
        id: 'expoSku',
        name: '曝光SKU数',
        desc: '曝光',
        value: formatPrice(datasource.expoSkuNums),
        labelContent: `${'SKU点击率'}${'\n'}${
          datasource.clickSkuRate ? formatPrice(Number(datasource.clickSkuRate) * 100) + '%' : '-'
        }`,
        textColor: '#2D64FF',
      },
      clickSku: {
        id: 'clickSku',
        name: '点击SKU数',
        desc: '点击',
        value: formatPrice(datasource.clickSkuNums),
        labelContent: `${'SKU动销率'}${'\n'}${
          datasource.saleSkuRate ? formatPrice(Number(datasource.saleSkuRate) * 100) + '%' : '-'
        }`,
        textColor: '#02B7FF',
      },
      zjOrdSku: {
        id: 'zjOrdSku',
        name: '直接引导成交sku数',
        desc: '成交',
        value: formatPrice(datasource.zjOrdSkuNums),
        textColor: '#17C574',
      },
    };
    const order = ['expoSku', 'clickSku', 'zjOrdSku'];

    const NewData = Object.assign(
      {},
      { rawData: rawData },
      { order: order },
      { lightColor: lightColor },
      { darkColor: darkColor }
    );
    return NewData;
  }
};
export default SkuEffect;
